// index.js
// Component for Client view

// Imports
import React from 'react';
import { Flex } from 'reflexbox';
import PropTypes from 'prop-types';
import Client from './Client';
import NewClient from './NewClient';
import OrderData from '../../data/Order';

// Component Class
// Shows client form
class ClientView extends React.Component {
  // Returns the current order total for a given client
  getOrderTotal = (clientId) => {
    var order = new OrderData(this.props.products, this.props.order.byClient[clientId]);
    return order.getTotal();
  };

  // Renders Component
  render() {
    var ids = this.props.clients.ids.slice();
    ids.sort((a, b) => {
      var nameA = this.props.clients.byId[a].name;
      var nameB = this.props.clients.byId[b].name;
      return nameA.localeCompare(nameB);
    });
    return (
      <Flex align='center' justify='center' w={1}>
        <table className="pt-html-table pt-html-table-striped pt-small" style={{width: '80%', padding: '0'}}>
          <thead>
            <tr>
              <th>Cliente</th>
              <th style={{width: '160px'}}>
                <center>Pedido Atual</center>
              </th>
              <th style={{width: '30px'}}>
                <center>Opções</center>
              </th>
            </tr>
          </thead>
          <tbody>
            {ids.map(id =>
              <Client
                key={id}
                client={this.props.clients.byId[id]}
                order={this.getOrderTotal(id)}
                rename={this.props.renameClient}
                remove={this.props.removeClient}
              />
            )}
            <tr>
              <td span="3">
                <NewClient add={this.props.addClient} />
              </td>
            </tr>
          </tbody>
        </table>
      </Flex>
    );
  }
}

// Required Properties
ClientView.propTypes = {
  clients: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  renameClient: PropTypes.func.isRequired,
  removeClient: PropTypes.func.isRequired,
}

// Exports
export default ClientView;


// WEBPACK FOOTER //
// ./src/components/ClientView/index.js